import { CreditCheckResult as Domain, CreditCheckType as DomainType } from 'modules/cm/Credit/Credit';
import { CreditCheckResult as API, CreditCheckType as ApiType } from 'modules/cm/api/cases/credit/Credit';
import { format } from 'utils/date';

const typeMap = new Map<ApiType, DomainType>([
  [ApiType.SOFT, DomainType.SOFT],
  [ApiType.HARD, DomainType.HARD],
  [ApiType.HARD_MANUAL, DomainType.HARD_MANUAL],
  [ApiType.SOFT_MANUAL, DomainType.SOFT_MANUAL],
]);

const mapCreditCheckResult = (api: API): Domain => ({
  ...api,
  type: typeMap.get(api.type) || 'UNKNOWN',
  dateOfSearch: format(api.dateOfSearch).fromBackendToView(),
});

export default mapCreditCheckResult;
